import React from 'react';
import TableRow from './TableRow';

const TableBody = ({ items }) => {
    const rows = items.map(item => <TableRow key={item.id} {...item} />);
    return <tbody>{rows}</tbody>;
};

export default TableBody;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Items/TableBody.js